import { ReactNode, useContext } from 'react';
import SignInContext from '../contexts/SignInContext.context';
import { USER_GROUPS } from '../types/users.types';

type Props = {
  children: ReactNode;
  onlyAdmins?: boolean;
  showInfo?: boolean;
};

const Guard = ({ children, onlyAdmins = false, showInfo = false }: Props) => {
  const { user } = useContext(SignInContext);

  if (onlyAdmins && !user.groups.includes(USER_GROUPS.ADMIN)) {
    if (showInfo) return <p className="p-4 text-lg">Only global admins can use this feature.</p>;
    return null;
  }

  return children;
};

export default Guard;
